// NotificationContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchNotificationCount } from "../../api";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [notificationData, setNotificationData] = useState({ totalcount: 0 });

    const updateNotificationCount = async () => {
        try {
            const data = await fetchNotificationCount(
                localStorage.getItem("user_type")
            );
            setNotificationData(data);
        } catch (error) {
            console.error("Error fetching notification count:", error);
        }
    };

    // Fetch initial count on mount
    useEffect(() => {
        updateNotificationCount();
    }, []);

    return (
        <NotificationContext.Provider value={{ notificationData, updateNotificationCount }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => useContext(NotificationContext);
